import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteReceiptDetails } from '../../Store/PHPSlice/ReceiptApi/receiptApi';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';

const TableBody = ({
    serialNumber,
    id,
    dt,
    fmnm,
    partyNm,
    rcptNo,
    paidAmt,
    apaidAmt,
    billNo,
    rcptType,
    sts,
  
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

 const handleDeleteClick = () => {
    const isConfirmed = window.confirm(
        "Are you sure you want to delete this Receipt Details?"
    );

    if (!isConfirmed) return;

    dispatch(deleteReceiptDetails({ id, rcptType }))
        .unwrap()
        .then((res) => {
            // Backend JSON response
            alert(res.msg);     // 👈 SHOW API MESSAGE
            window.location.reload();
        })
        .catch((error) => {
            console.error("Error deleting receipt:", error);
            alert(error?.msg || "Failed to delete receipt");
        });
};


    const handleViewClick = () => {
        window.open(`/press-info/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };



    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

   const handleReturnClick = () => {
  window.open(
    `/rcptPrint/${id}/${rcptType}`,
    '_blank',
    'width=1200,height=700,scrollbars=yes,resizable=yes'
  );
};


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {fmnm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>
                <TableCell
  sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontWeight: 'bold' }}
  align="center"
>
  {rcptType === "adv"
    ? "Advance Receipt"
    : rcptType === "return"
    ? "Return Receipt"
    : rcptType === "bill"
    ? "Bill Receipt"
    : rcptType}
</TableCell>

               

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {rcptNo}
                </TableCell>
                 <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {billNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {paidAmt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {apaidAmt}
                </TableCell>
                
                              

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button  variant="contained" size="small"  color="secondary" onClick={handleReturnClick} >Rcpt Print</Button>
                </TableCell>
                 {/* ⭐ Status Color */}
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                
                                    {sts === "1" ? (
                                        <button
                                            style={{
                                                backgroundColor: "green",
                                                color: "white",
                                                padding: "4px 12px",
                                                border: "none",
                                                borderRadius: "4px",
                                                fontWeight: "bold",
                                                cursor: "default"
                                            }}
                                        >
                                            Updated
                                        </button>
                                    ) : (
                                        <button
                                            style={{
                                                backgroundColor: "red",
                                                color: "white",
                                                padding: "4px 12px",
                                                border: "none",
                                                borderRadius: "4px",
                                                fontWeight: "bold",
                                                cursor: "default"
                                            }}
                                        >
                                            Pending
                                        </button>
                                    )}
                                </TableCell>
                        <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon onClick={handleDeleteClick} className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`}/>
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
